export const SET_IS_USER_ONBOARDING = "SET_IS_USER_ONBOARDING";

export const setIsUserOnboarding = isUserOnboarding => {
  return {
    type: SET_IS_USER_ONBOARDING,
    payload: isUserOnboarding
  };
};
